module.exports = __webpack_public_path__ + "static/media/nodeAutoReload.ce329cb3.png";